import { render, staticRenderFns } from "./HomestayAgreementC.vue?vue&type=template&id=74687dfc&scoped=true&"
import script from "./HomestayAgreementC.vue?vue&type=script&lang=js&"
export * from "./HomestayAgreementC.vue?vue&type=script&lang=js&"
import style0 from "./HomestayAgreementC.vue?vue&type=style&index=0&id=74687dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74687dfc",
  null
  
)

export default component.exports